import React from "react";
import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export const InfoBanner = ({ title, children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 1.5,
        p: 2,
        borderRadius: 1.5,
        backgroundColor: "rgba(0, 82, 204, 0.08)", // Atlassian blue with transparency
        borderLeft: "4px solid #0052CC", // Confluence accent line
      }}
    >
      <InfoOutlinedIcon sx={{ color: "#0052CC", mt: 0.3 }} />
      <Box>
        {title && (
          <Typography
            variant="subtitle1"
            fontWeight={600}
            sx={{ color: "#172B4D", mb: 0.3 }}
          >
            {title}
          </Typography>
        )}
        <Typography variant="body2" sx={{ color: "#172B4D" }}>
          {children}
        </Typography>
      </Box>
    </Box>
  );
}